import React, { useEffect } from "react";
import useStyles from "./styles";
import { Grid, Typography, Box, Divider } from "@material-ui/core";
import { FormProvider } from "react-hook-form";
import { DPButton } from "Components/DP";
import useCreateAdminForm from "./useCreateAdminForm";
import {
  PersonalDetailsFormTextFields
} from "Components/Shared/FormComponents/PersonalDetailsFormTextFields/PersonalDetailsFormTextFields";
import { CreateAdminFormSelects } from "./CreateAdminFormSelects";

type CreateAdminFormProps = {
  handleClose: () => void;
  page: number;
};

const CreateAdminForm = ({ handleClose, page }: CreateAdminFormProps) => {
  const classes = useStyles();
  const { onSubmit, useFormMethodsAndData } = useCreateAdminForm({
    handleClose,
    page,
  });
  const { errors, register } = useFormMethodsAndData;

  useEffect(() => {
    register({ name: "companyIds" });
    register({ name: "locations" });
  }, [register]);

  return (
    <FormProvider {...useFormMethodsAndData}>
      <form id={"create-admin-form"} onSubmit={onSubmit}>
        <Box m={4} className={classes.formFieldsBox}>
          <Typography variant="h2" className={classes.title}>
            Create New Admin
          </Typography>
          <Typography variant="h3">Basic information</Typography>
          <PersonalDetailsFormTextFields
            errors={errors}
            register={register}
          />
          <Typography variant="h3">Permissions</Typography>
          <CreateAdminFormSelects />
        </Box>
        <Divider />
        <Box m={4}>
          <Grid container justify="center">
            <DPButton color="default" align="right" onClick={handleClose}>
              Cancel
            </DPButton>
            <DPButton id="submit-btn" type={"submit"} align="right">
              Submit
            </DPButton>
          </Grid>
        </Box>
      </form>
    </FormProvider>
  );
};

export default CreateAdminForm;
